import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chamiliElafron';
const args = {};

export class ChamiliElafron extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
